import {
  AdminIcon,
  AddVoucher,
  detailedView,
  condenced,
  period,
  groups,
  ledgerWise,
  unCollapse,
  collapse,
  reports
} from './images';
// import { AddItemText } from './components/Voucher/AddVoucherStyledComponents';

export const ThemeDefaultValues = {
  report: {
    detailedView: detailedView,
    condenced: condenced,
    period: period,
    ledgerWise: groups,
    groups: ledgerWise,
    unCollapse: unCollapse,
    collapse: collapse,
    reports: reports
  },
  addVoucherImage: {
    partyLinkImg: AdminIcon,
    voucherDetailsImg: AddVoucher,
    shippingDetailsImg: AdminIcon,
    transportDetailsImg: AdminIcon,
    voucherRefNoImg: AdminIcon
  },
  baseFontFamily: 'roboto',
  baseFontSize: '16px',
  cardHeaderFontSize: '14px',
  cardHeaderFontColor: '#4545',
  cardBackgroundColor: 'rgba(134, 134, 134, 0.03);',
  cardSubHeaderFontSize: '15px',

  tabFontFamily: 'roboto',
  tabFontWeight: '400',
  tabFontColor: '#868686',
  tabFontSize: '12px',

  addLinkColor: 'rgb(36,0,255,0.9)',
  containerBorderColor: 'rgba(112, 112, 112, 0.2)'
};
